// extracted by mini-css-extract-plugin
export default {"modal":"ModalBox_modal__X96RD","modalContent":"ModalBox_modalContent__yd5-K","close":"ModalBox_close__6MbwU"};